/**
 * @generated SignedSource<<8f37452143a0514c28f61a9984c1fbd3>>
 * @relayHash 4834575fb55a970c7efc7b0ab4b5cc75
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4834575fb55a970c7efc7b0ab4b5cc75

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImpersonateUserInput = {
  clientMutationId?: string | null;
  courseId?: string | null;
  userId: string;
};
export type homeImpersonateMutation$variables = {
  input: ImpersonateUserInput;
};
export type homeImpersonateMutation$data = {
  readonly impersonateUser: {
    readonly success: boolean;
  } | null;
};
export type homeImpersonateMutation = {
  response: homeImpersonateMutation$data;
  variables: homeImpersonateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImpersonateUserPayload",
    "kind": "LinkedField",
    "name": "impersonateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homeImpersonateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homeImpersonateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4834575fb55a970c7efc7b0ab4b5cc75",
    "metadata": {},
    "name": "homeImpersonateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a09f7516ec4bbe76b3f4caa039d77d80";

export default node;
